import {
  type NftContract,
  type INFTContract,
  type IAppPromotion,
  type ICoinInfo,
  type IReferralEvent,
  NFTTokenContentType,
} from 'oscar-typedef'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import WepinBackendAPI from '@/networks/api/wepin/WepinBackendAPI'
import { useUserAPIStore } from '@/stores'

export interface PromotionInfomation {
  Promotion: IAppPromotion
  Contract: INFTContract
  Coin: ICoinInfo
}
export interface EventProcessInfo {
  id: number
  contentId: string
}

/**
 * 다른 스토어들과 달리 API / Class 두개의 store 로 구분하지 않고 하나의 store로 구현
 */
export const useNftPromotionStore = defineStore('nftPromotion', () => {
  const userAPIStore = useUserAPIStore()
  const promotion = ref<PromotionInfomation>()
  const isFetched = ref(false)
  const processingInfo = ref<EventProcessInfo>({
    id: 0,
    contentId: '',
  })
  const userPromotionSituation = ref<IReferralEvent[]>()

  async function fetchPromotionInfo(
    id: string,
    force?: boolean,
  ): Promise<PromotionInfomation> {
    if (isFetched.value && !force) return promotion.value!

    const promotionRes =
      await WepinBackendAPI.getInstance().project.getAppPromotion(
        id,
        userAPIStore.userInfo?.localeId,
      )

    if (!promotionRes.appPromotion) {
      throw new Error('Promotion is not exist')
    }

    const currentTime: any = new Date()
    const startTime: any = new Date(promotionRes.appPromotion.startDate)
    if (startTime > currentTime) {
      throw new Error('Promotion is not exist')
    }

    const nftContractId = promotionRes.appPromotion.nftContractId.toString()
    const contractInfoRes: NftContract.GetNFTContract.Response.Body =
      await WepinBackendAPI.getInstance().nftcontract.getNFTContractWithoutSession(
        {
          nftContractId: nftContractId,
        },
      )

    if (!contractInfoRes.nftContract) {
      throw new Error('NFT Contract is not exist')
    }

    const coinInfoRes =
      await WepinBackendAPI.getInstance().coin.getCoinInfoListWithoutSession({
        ids: String(contractInfoRes.nftContract.coinId),
      })

    if (!coinInfoRes.coins.length) {
      throw new Error('Abnomal coin infomation')
    }
    const promotionInfomation = {
      Promotion: promotionRes.appPromotion,
      Contract: contractInfoRes.nftContract,
      Coin: coinInfoRes.coins[0],
    }
    //
    promotion.value = promotionInfomation
    isFetched.value = true

    return promotionInfomation
  }

  function getContentsInfo(contentId?: string) {
    if (!promotion.value) throw new Error('Promotion is not exist')
    const promotionData = promotion.value.Promotion
    const contractData = promotion.value.Contract
    const coinInfoData = promotion.value.Coin

    if (!promotionData.appPromotionContent)
      throw new Error('AppPromotionContent is not exist')

    const content =
      promotionData.appPromotionContent?.find((e: any) => e.id === contentId) ||
      promotionData.appPromotionContent?.find((e: any) => e.isDefault) ||
      promotionData.appPromotionContent[0]
    const metadata = (content?.detail as { metadata: any }).metadata
    const thumbnail = (content?.detail as { thumbnail?: string }).thumbnail

    const useThumbnail =
      content.contentType === NFTTokenContentType.video && thumbnail
    const imageUrl = metadata.image
    let addtionalUrl = ''
    if (metadata.addtionalUrl) {
      addtionalUrl = metadata.addtionalUrl[0]?.image
    }
    return {
      imageUrl: imageUrl as string,
      contractName: contractData.name,
      tokenName: metadata.name as string,
      networkName: coinInfoData.name as string,
      contentType: content.contentType as number,
      iconUrl: coinInfoData.iconUrl as string,
      desc: metadata.description as string,
      addtionalUrl: addtionalUrl,
      thumbnail,
      useThumbnail,
    }
  }

  async function getReferralAppPromotionList() {
    const res =
      await WepinBackendAPI.getInstance().project.getReferralAppPromotionList()
    if (!res) return
    userPromotionSituation.value = res.events
    return res
  }

  async function getAppPromotionMintContent(
    promotionId: string,
    email: string,
  ) {
    const res =
      await WepinBackendAPI.getInstance().project.getAppPromotionMintContent(
        promotionId,
        { email },
      )
    if (!res) return
    return res
  }

  // function setProcessInfo(
  //   promotionInfo: PromotionInfomation,
  //   contentId: string
  // ) {
  //   processingInfo.value.id = promotionInfo.Promotion.id
  //   processingInfo.value.contentId = contentId
  // }
  // function getProcessInfo() {
  //   return processingInfo.value
  // }
  const reset = () => {
    promotion.value = undefined
    processingInfo.value = {
      id: 0,
      contentId: '',
    }

    userPromotionSituation.value = []
  }
  return {
    promotion,
    reset,
    userPromotionSituation,
    fetchPromotionInfo,
    getContentsInfo,
    getReferralAppPromotionList,
    getAppPromotionMintContent,
    // setProcessInfo,
    // getProcessInfo,
  }
})
